module.exports = __webpack_public_path__ + "img/pg.03f26e44.jpg";